import { useEffect, useState } from "react";
import { getLiveTrackingTrips } from "modules/clientProjects/api";

const RECORDS_PER_PAGE = 10;

export default function useTrips(currentPage, selectedFilters, search) {
    const [tripsData, setTripsData] = useState({
        trips: [],
        drivers: [],
        truckTypes: [],
        tripPoints: [],
        trucks: [],
        totalRecords: 0,
    });

    useEffect(() => {
        const fetchTrips = async () => {
            if (!search || (search && Object.values(selectedFilters).length > 0)) {
                try {
                    const response = await getLiveTrackingTrips(
                        currentPage,
                        RECORDS_PER_PAGE,
                        selectedFilters,
                        search
                    );
                    const { entities, meta } = response;

                    setTripsData({
                        trips: Object.values(entities.trips || {}),
                        drivers: Object.values(entities.drivers || {}),
                        truckTypes: Object.values(entities.truckTypes || {}),
                        tripPoints: Object.values(entities.tripPoints || {}),
                        trucks: Object.values(entities.trucks || {}),
                        totalRecords: meta?.totalRecordCount || 0,
                    });
                } catch (error) {
                    console.error("Error fetching trips:", error);
                }
            }
        };
        fetchTrips();
    }, [currentPage, selectedFilters, search]);

    return tripsData;
}
